const setFeatureState = (
    map: mapboxgl.Map,
    variant: string,
    id: string,
    type: 'hover' | 'focus',
    value: boolean,
) => {
    map.setFeatureState(
        {
            source: variant,
            id,
        },
        {
            [type]: value,
        },
    );
};

export default setFeatureState;
